import React, { useState, useEffect } from "react";
import { ProductList } from "../../vendor/ProductList";
import { User, firestore } from "firebase";
import firebase from "firebase";
import { Product } from "../../profile/Profile";
import isNil from "lodash/isNil";
import Select from "react-select";
import { productCategories } from "../../vendor/product/data/productCategories";
import { ReactSelectOption } from "../../common/FormikReactSelect";

interface SearchProps {
  user: User;
  profile: firebase.firestore.DocumentData;
}

const db = firebase.firestore();

export const Search = ({user, profile}: SearchProps) => {
  const allOption = {
    label: "All",
    value: "all"
  };

  const [products, setProducts] = useState<Product[]>([] as Product[]);
  const [selectedCategory, setSelectedCategory] = useState<ReactSelectOption>(allOption);

  useEffect(() => {
    if (!isNil(user)) {
      let productQuery: firebase.firestore.Query = db.collection("products");
      if (selectedCategory.value !== allOption.value) {
        productQuery = productQuery.where("category", "==", selectedCategory.value);
      }
        
      productQuery.onSnapshot(snapshot => {
        const updatedProducts = snapshot.docs.map(doc => {
          return {
            id: doc.id,
            productData: doc.data(),
          };
        });
        setProducts(updatedProducts);
      });

      // detach listner
      return () => productQuery.onSnapshot(() => {})();
    }     
  }, [user, selectedCategory, allOption]);

  return (
    <>
      <div className="filter">
        <div>Category</div>
        <div>
          <Select 
            options={[allOption, ...productCategories]}
            value={selectedCategory}
            onChange={(newOption) => {
              setSelectedCategory((newOption as ReactSelectOption));
            }}
          ></Select>
        </div>
        <div>Annual Revenue</div>
        <div>
          <Select 
            options={[allOption, ...productCategories]}
            value={selectedCategory}
            onChange={(newOption) => {
              setSelectedCategory((newOption as ReactSelectOption));
            }}
          ></Select>
        </div>
      </div>
      <ProductList products={products}></ProductList>
    </>
  );
}